import { useState, useCallback, Dispatch, SetStateAction } from "react";

export function useSessionStorage<T>(key: string, initialValue: T): [T, Dispatch<SetStateAction<T>>] {
  const [storedValue, setStoredValue] = useState<T>(() => {
    try {
      const item = window.sessionStorage.getItem(key);
      return item ? JSON.parse(item) : initialValue;
    } catch {
      // Storage bloqueado (aba privada) ou valor corrompido: começa do zero.
      return initialValue;
    }
  });

  const setValue: Dispatch<SetStateAction<T>> = useCallback((value) => {
    setStoredValue((prevState) => {
      const valueToStore = value instanceof Function ? value(prevState) : value;
      // O updater roda depois, na renderização: o try precisa estar aqui dentro.
      try {
        window.sessionStorage.setItem(key, JSON.stringify(valueToStore));
      } catch {
        // Storage cheio ou bloqueado: o estado continua só em memória.
      }
      return valueToStore;
    });
  }, [key]);

  return [storedValue, setValue];
}
